import React, { useState, useEffect } from 'react';
import { getTopCustomers } from '../../services/apiServices';
import { Link } from 'react-router-dom';
import SalesChart from '../components/SalesChart';

function Dashboard() {
    const [topCustomersData, setTopCustomersData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchTopCustomersData();
    }, []);

    const fetchTopCustomersData = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await getTopCustomers();
            setTopCustomersData(response.data);
        } catch (err) {
            setError(err.message || 'Failed to fetch top customers data');
            console.error('Top Customers API Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleChartDataUpdate = async (chartData) => {
        console.log('Chart data updated:', chartData.data);
        if (chartData.data) {
            setTopCustomersData(chartData.data);
        }
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    const formatNumber = (num) => {
        return new Intl.NumberFormat('en-US').format(num);
    };

    if (loading) {
        return (
            <div className="right-section">
                <div className="loader-overlay">
                    <span className="loader"></span>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="right-section">
                <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                        <div className="dashboard-box">
                            <span>
                                <img src={window.getPublicUrl('admin/images/revenue.svg')} alt="icon" />
                            </span>
                            <h4>Total Revenue</h4>
                            <h3>{topCustomersData ? formatCurrency(topCustomersData.total_revenue) : '$0'}</h3>
                        </div>
                    </div>
                    </div>
                      <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <SalesChart onDataUpdate={handleChartDataUpdate} />
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <div className="sales-graph">
                            <h3>Top 5 Customers</h3>
                            <h4>Highest spending customers</h4>
                            <Link to="/admin/customers">
                                <button className="see-all">
                                See All Customers <img src={window.getPublicUrl('admin/images/see-all.svg')} alt="icon" />
                            </button></Link>
                        
                            <div className="bundle-table">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Customer</th>
                                            <th scope="col">Email</th>
                                            <th scope="col">Bundles Bought</th>
                                            <th scope="col">Total Spent</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {topCustomersData && topCustomersData.top_customers ? (
                                            topCustomersData.top_customers.map((customer, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="customer-info">
                                                          
                                                            <p>{customer.name || 'N/A'}</p>
                                                        </div>
                                                    </td>
                                                    <td>{customer.email}</td>
                                                    <td>{formatNumber(customer.bundles_bought)}</td>
                                                    <td>{formatCurrency(parseFloat(customer.total_spent))}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center">No data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;
